var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInhaler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#01cfce",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1571a5",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5204_11524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1477 12.0127L25.8104 1.98357C25.637 0.683167 24.4044 -0.20713 23.1122 0.0417993L4.97252 3.54251C3.7818 3.77224 2.97773 4.89242 3.14119 6.09426L4.62685 17.0152L27.1477 12.0127Z",
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3007 55.1176L54.2598 55.1359L54.3629 73.3288L57.4203 73.3105C59.5165 73.2942 61.2118 71.5753 61.1992 69.4789L61.135 58.9026C61.1216 56.7661 59.3587 55.0874 57.3007 55.1176Z",
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.746 55.0319L73.3163 53.5085C74.5135 53.1094 75.1605 51.8152 74.7616 50.6179C74.3624 49.4207 73.0683 48.7734 71.871 49.1726L67.3007 50.6961C66.1034 51.0952 65.4564 52.3894 65.8554 53.5867C66.2553 54.7862 67.551 55.4303 68.746 55.0319Z",
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5937 59.7188H68.0234C66.7614 59.7188 65.7382 60.7419 65.7382 62.0039C65.7382 63.2659 66.7614 64.2891 68.0234 64.2891H72.5937C73.8557 64.2891 74.8788 63.2659 74.8788 62.0039C74.8788 60.7419 73.8557 59.7188 72.5937 59.7188Z",
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3004 70.5006L68.7301 68.9772C67.533 68.5783 66.2387 69.2252 65.8395 70.4224C65.4405 71.6197 66.0875 72.9139 67.2848 73.313L71.8551 74.8364C73.0522 75.2354 74.3464 74.5884 74.7457 73.3912C75.1448 72.1939 74.4978 70.8997 73.3004 70.5006Z",
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3917 50.5785H35.7394L31.4335 18.2845C31.2567 16.9577 29.9804 16.0655 28.6729 16.3557L5.46063 21.512C4.30633 21.7684 3.53837 22.8632 3.68995 24.0357L4.60568 31.1191L18.9128 27.8285C20.1421 27.5454 21.3692 28.3132 21.652 29.5433C21.9349 30.7733 21.1671 31.9996 19.9372 32.2824L5.19434 35.6732L5.76471 40.0851L20.0857 36.7913C21.3153 36.5084 22.542 37.2762 22.8249 38.5061C23.1078 39.7361 22.3399 40.9624 21.1101 41.2452L6.35336 44.6392L10.4092 76.0082C10.5565 77.1476 11.5266 78.0004 12.6755 78.0004H47.5209C48.7876 78.0004 49.8132 76.9689 49.8061 75.7023L49.6764 52.8508C49.6697 51.5937 48.6487 50.5785 47.3917 50.5785Z",
    fill: "url(#gradient)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5204_11524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhaler);
export default __webpack_public_path__ + "static/media/inhaler.9dcc84609af5c7366f5302341ad5232b.svg";
export { ForwardRef as ReactComponent };